<template>
	<div class="flex gap-3">
		<div class="w-[98px]">
			<NuxtImg
				:src="imageSrc"
				:alt="product.Name"
				class="max-h-full max-w-full w-full object-contain cursor-pointer"
				:loading="lazyLoading ? 'lazy' : 'eager'"
				:preload="!lazyLoading"
				sizes="20vw md:50vw"
				width="364"
				height="546"
			/>
		</div>
		<div class="flex flex-grow justify-between items-center">
			<div>
				<p class="font-medium text-base text-left">
					{{ product.Name }}
				</p>
				<PriceGate>
					<p class="font-medium text-base text-left">
						{{ formatPrice(product.PriceIncVat) }}
					</p>
				</PriceGate>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

interface Props {
	product: ProductItem;
	lazyLoading?: boolean;
}
const { product, lazyLoading } = defineProps<Props>();

const productStore = useProductStore();
const { formatPrice } = useFormatPrice();

const imageSrc = computed(() => {
	const defaultImage =
		productStore.defaultProductImage || "images/product/no_image.jpeg";

	return product.Files?.[0]?.Path
		? `${product.Files[0].Path} ?mode=max&format=webp&w=390`
		: defaultImage;
});
</script>
